<template>
  <div>
    <v-layout v-for="(text, index) in textArray" :key="index" row wrap>
      <v-flex xs11>
        <v-text-field
          ref="input"
          :value="text"
          :placeholder="'メールアドレス' + (index + 1)"
          @input="inputText($event, index)"
          @keydown.enter="onPressEnter(index)"
        />
      </v-flex>
      <v-flex xs1>
        <v-btn
          v-if="index !== 0"
          @click="removeTextField(index)"
          fab
          dark
          small
          depressed
          color="secondary"
        >
          <v-icon dark>remove</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-btn @click="addTextField" fab dark small depressed color="primary">
      <v-icon dark>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    textArray() {
      if (this.value.length === 0) {
        // カラ配列だとaddボタンが表示できない
        return ['']
      }
      return this.value
    },
  },
  methods: {
    inputText(text, index) {
      this.$emit('inputText', { text: text, index: index })
      // inputでcopyすると描画に影響するくらい重いので別出し
      // 親コンポーネントではpropsのvalueに渡す配列を配列として定義してある必要あり
    },
    async addTextField() {
      // 値渡しコピー
      const copy = this.textArray.slice()
      copy.push('')
      this.$emit('add')
      this.$emit('input', copy)
      await this.$nextTick
      this.$refs.input[copy.length - 1].focus()
    },
    removeTextField(index) {
      const copy = this.value.slice()
      copy.splice(index, 1)
      this.$emit('remove', this.value[index])
      this.$emit('input', copy)
    },
    /**
     * 最終行なら追加、途中行なら次の行へ移動
     */
    onPressEnter(index) {
      if (index === this.textArray.length - 1) {
        this.addTextField()
      } else {
        this.$refs.input[index + 1].focus()
      }
    },
  },
}
</script>

<style scoped>
.v-text-field >>> .v-text-field__details {
  height: 0px !important;
}
.v-text-field >>> .v-input__slot {
  margin: 0 !important;
}
</style>
